import React from 'react';
import { Tooltip } from 'antd';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LanguageIcon from '@components/LanguageIcon';
import { createLanguageFilters } from '@utils/supportedLanguages';
import { contentTypes, messageTypes } from '@utils';
import { Audience } from '../SentList/createColumns';

export default t => [
  {
    className: 'language-column',
    title: t('cards:ScheduledMessagesList.columns.language.title'),
    dataIndex: ['metadata', 'language'],
    key: 'language',
    render: language => {
      return <LanguageIcon language={language} />;
    },
    width: 150,
    filters: createLanguageFilters(t),
    onFilter: (value, record) => record.metadata.language === value,
  },
  {
    title: t('cards:ScheduledMessagesList.columns.type.title'),
    dataIndex: ['metadata', 'type'],
    key: 'metadata-type',
    render: type => (
      <Tooltip placement="bottom" title={t(contentTypes[type.toUpperCase()].label)}>
        <FontAwesomeIcon size="lg" icon={contentTypes[type.toUpperCase()].icon} />
      </Tooltip>
    ),
    width: 130,
    sorter: (a, b) => a.metadata.type.localeCompare(b.metadata.type),
    filters: messageTypes.map(type => ({ text: t(contentTypes[type].label), value: type })),
    onFilter: (value, record) => record.metadata.type.toUpperCase() === value,
  },
  {
    title: t('cards:ScheduledMessagesList.columns.sendAt'),
    dataIndex: 'nextSendDatetime',
    key: 'nextSendDatetime-date',
    width: 200,
    ellipsis: true,
    sorter: (a, b) => a.nextSendDatetime > b.nextSendDatetime,
    render: dateString => {
      const sentMoment = moment(dateString);

      return `${sentMoment.format('L')} ${sentMoment.format('LT')}`;
    },
  },
  {
    title: t('cards:ScheduledMessagesList.columns.audience'),
    dataIndex: 'audienceDisplay',
    key: 'audience',
    ellipsis: true,
    render: (audienceDisplay, record) => (
      <Audience audienceDisplay={audienceDisplay} t={t} users={record.users} />
    ),
  },
  {
    title: t('cards:ScheduledMessagesList.columns.title'),
    dataIndex: 'title',
    key: 'title',
    ellipsis: true,
  },
];
